import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var CANONICAL_PARAMS = {
  page: function page(v) {
    return parseInt(v) == v && v >= -1;
  }
};

var getCanonicalParams = function getCanonicalParams(url) {
  try {
    var _URL = new URL(url),
        searchParams = _URL.searchParams;

    var paramsArray = _toConsumableArray(searchParams);

    paramsArray.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      if (!CANONICAL_PARAMS[key] || !CANONICAL_PARAMS[key](value)) {
        searchParams.delete(key);
      }
    });
    return searchParams.toString();
  } catch (e) {
    return null;
  }
};

export var robotsContent = function robotsContent(_ref3) {
  var _ref3$robotsMeta = _ref3.robotsMeta,
      robotsMeta = _ref3$robotsMeta === void 0 ? ['all'] : _ref3$robotsMeta;
  return robotsMeta.join(',').trim();
};
export var canonicalHref = function canonicalHref(_ref4) {
  var canonical = _ref4.canonical,
      href = _ref4.href;
  var url = new URL(canonical || href);
  url.protocol = 'https:';
  url.search = getCanonicalParams(canonical) || getCanonicalParams(href);
  return url.toString();
};
//# sourceMappingURL=meta-tags.js.map